import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { updateGuestReservationSearchQuery } from '../../../actions/components/reservation-search';

const initialState = {
  query: { q: '' }
};

const onChangeSearchQueryHandler = action => ({
  [action.toString()]: (state, { payload: query }) => set(`query`, query, state)
});

export default createReducer(initialState, {
  ...onChangeSearchQueryHandler(updateGuestReservationSearchQuery)
});
